export default __webpack_public_path__ + "static/media/0x2cf7252e74036d1da831d11089d326296e64a728.41780b10.svg";